import { render, staticRenderFns } from "./CourseDate.vue?vue&type=template&id=ffba0114&scoped=true&"
import script from "./CourseDate.vue?vue&type=script&lang=js&"
export * from "./CourseDate.vue?vue&type=script&lang=js&"
import style0 from "./CourseDate.vue?vue&type=style&index=0&id=ffba0114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffba0114",
  null
  
)

export default component.exports